// extracted by mini-css-extract-plugin
module.exports = {"pageTitleBar":"style_pageTitleBar__NzXOD","center":"style_center__jy6o7","title":"style_title___Blbz"};